import LinkTable from '../components/LinkTable';
import { saveLink } from '../utils/GraphqlUtils';

function Database() {
  saveLink({
    url: '/database',
    description: 'Access DB'
  });
  return (
    <div>
      <LinkTable/>
    </div>
  );
}

export default Database;